package uz.ferro.erp.feature.text.ui

import react.FC
import react.PropsWithChildren
import uz.ferro.erp.feature.text.model.DocItem
import uz.ferro.erp.feature.text.model.DocItemType

external interface DocItemProps : PropsWithChildren {
    var item: DocItem
}

val DocItemView = FC<DocItemProps> { props ->
    val item = props.item

    when (item.type) {
        DocItemType.LIST -> DocListView {
            this.item = item
        }
        DocItemType.TEXT,
        DocItemType.FORMATTED_TEXT-> DocTextView {
            this.item = item
        }
        DocItemType.LINK -> DocLinkView {
            this.item = item
        }
        DocItemType.IMAGE -> DocImageView {
            this.item = item
        }
    }
}